import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";

import { PandaDocEmbeddedSessionLoader } from "./PandaDocEmbeddedSessionLoader";
import { PandaDocEmbeddedSigning } from "./PandaDocEmbeddedSigning";

interface PandaDocSigningContentProps {
  isLoading: boolean;
  pandaDocSessionId: string | undefined;
  onDocumentLoaded: () => void;
  onDocumentRendered: () => void;
  onError: () => void;
  onComplete: () => void;
}

export function PandaDocSigningContent(props: PandaDocSigningContentProps) {
  const {
    isLoading,
    pandaDocSessionId,
    onDocumentLoaded,
    onDocumentRendered,
    onError,
    onComplete,
  } = props;

  return (
    <>
      {isLoading && <PandaDocEmbeddedSessionLoader />}
      <Box
        sx={{
          height: isLoading ? "0" : "100%",
          overflow: "auto",
          visibility: isLoading ? "hidden" : "visible",
        }}
      >
        {isDefined(pandaDocSessionId) && (
          <PandaDocEmbeddedSigning
            pandaDocSessionId={pandaDocSessionId}
            onDocumentLoaded={onDocumentLoaded}
            onDocumentRendered={onDocumentRendered}
            onError={onError}
            onComplete={onComplete}
          />
        )}
      </Box>
    </>
  );
}
